<template>
  <ODialog ref="dialog" :max-width="1200" hideWhenLoading>
    <v-card v-if="row != null">
      <ODialogBar
        title="Dicionário CAN"
        :subtitle="subtitle"
        @close="dismiss"
      />
      <v-card-text class="dialog-main">
        <div class="dialog-sidebar">
          <DesktopSideBar :tabItems="tabItems" :currentTab.sync="currentTab" />
        </div>

        <div class="dialog-tab-content">
          <TabContainer
            @reload="reload"
            :tabItems="tabItems"
            :currentTab="currentTab"
            :value="row"
          />
        </div>
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
import DesktopSideBar from 'oderon-vue/cpts/tabbed-interface/DesktopSideBar.vue'
import TabContainer from 'oderon-vue/cpts/tabbed-interface/TabContainer.vue'
import EditStore from './EditStore'

export default {
  components: {
    DesktopSideBar,
    TabContainer
  },
  data() {
    return { currentTab: 'overview' }
  },
  computed: {
    row() {
      return EditStore.row
    },
    subtitle() {
      return this.row && this.row.id && `#${this.row.id}`
    },
    tabItems() {
      return EditStore.tabItems
    }
  },
  methods: {
    open(id) {
      this.$refs.dialog.$loading(() => EditStore.load(id))
      return this.$refs.dialog.$open()
    },
    reload() {
      this.$refs.dialog.$loading(() => EditStore.load(this.row.id))
    },
    dismiss() {
      return this.$refs.dialog.$dismiss()
    }
  }
}
</script>

<style lang="sass"></style>
